import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'
import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import { callApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'

const mapStateToProps = (state) => {
    return {
        accountTypes: state.adminAccountTypes
    }
}

const AdminAccountCreate = ({ dispatch, navigate, params, accountTypes }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/account-types', 'LIST')))
    }, [dispatch])

    // not a function
    const accountTypeOptions = accountTypes?.map(type => ({
        label: type.name,
        value: type.id
    }))

    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint('admin/accounts', 'CREATE'), formData, formId))
    }

    const successFX = (accountId) => {
        navigate(buildRoutePath(routes.adminAccountDashboard.path, { accountId }))
    }
    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Create New Account</h1>
                        <p>Use the form below to create a new account.</p>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    <div className="content-box editable">
                        <SHSForm
                            extraClass="flex-form"
                            submitFX={submitFX}
                            successFX={successFX}
                            showCancel={true}
                            cancelAction={() => navigate(buildRoutePath(routes.adminAccountsIndex.path))}>
                            <InputElement
                                type="text"
                                id="name"
                                label="Name"
                                placeholder="Optimus Tech Account"
                                required />
                            <InputElement
                                type="valueSelect"
                                id="accountTypeId"
                                label="Account Type"
                                options={accountTypeOptions}
                                required />
                        </SHSForm>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminAccountCreate))
